import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e1637f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header_box"
}
const _hoisted_2 = { class: "header_content" }
const _hoisted_3 = { class: "content_left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "login_header" }
const _hoisted_6 = {
  key: 1,
  class: "content"
}
const _hoisted_7 = { class: "wrap_from_top" }
const _hoisted_8 = { class: "form_item" }
const _hoisted_9 = { class: "wrap_from_bottom" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "form_input" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "form_bottom" }
const _hoisted_14 = { class: "wrap_form_btn" }
const _hoisted_15 = { class: "wrap_active" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_17 = { class: "wrap_button" }
const _hoisted_18 = {
  key: 2,
  class: "content"
}
const _hoisted_19 = { class: "right_conteng" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "账户密码重置", -1))
const _hoisted_21 = {
  key: 0,
  class: "wrap_form"
}
const _hoisted_22 = { class: "wrap_form_center" }
const _hoisted_23 = { class: "form_item" }
const _hoisted_24 = { class: "wrap_form_bottom" }
const _hoisted_25 = { class: "form_bottom" }
const _hoisted_26 = { class: "wrap_form_btn" }
const _hoisted_27 = { class: "wrap_form_three" }
const _hoisted_28 = { class: "form_input" }
const _hoisted_29 = { class: "wrap_form_three" }
const _hoisted_30 = { class: "form_foot" }
const _hoisted_31 = { class: "wrap_active" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_33 = { class: "wrap_button" }
const _hoisted_34 = {
  key: 3,
  class: "footer"
}

import { message, Input } from 'ant-design-vue';
import http from '@/api/login';
import { computed, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { formatRoutes } from '@/router';
import { getDisplay, getMenuVisibleRouterKey } from '@/plugins/cookie';
import { stripingColumns } from './application/type';

interface Ilogin {
  username: number | string;
  password: string;
  code: string;
}
interface Subforgot {
  username: number | string;
  password: string;
  passwords: string;
  code: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'subLogin',
  setup(__props) {

const aInput = Input;
const store = useStore();
const route = useRoute();
const router = useRouter();

const headerNavVisiable = computed(() => route.query[getMenuVisibleRouterKey()] != '1');
// const customData = computed(() => store.state.home.customData);
const defaultTopLogo = process.env.VUE_APP_OTHER_LINK+'/top_logo.png';
const CodeShake = ref<boolean>(false);
const studioId = router.currentRoute.value.params.studioId;
//登录
const formData: Ilogin = reactive({
  username: '',
  password: '',
  code: '',
});
//忘记密码
const formDatas: Subforgot = reactive({
  username: '',
  password: '',
  passwords: '',
  code: '',
});
// 登录
const isShowform = ref(true);
// 倒计时
let isShowcode = ref(true);
let isShowcodes = ref(true);
let timer: any = ref(0);
const TIME_COUNT = 60;
let count = ref(TIME_COUNT);
let counts = ref(TIME_COUNT);
const getCode = () => {
  // 正则表达式
  var reg = /^1[0-9]{10}$/;
  if (isLogin.value == true) {
    if (!reg.test(formData.username as string)) {
      message.info('请输入正确的手机号');
      return false;
    }
    if (!timer.value) {
      count.value = TIME_COUNT;
      isShowcode.value = false;
      timer.value = setInterval(() => {
        if (count.value > 0 && count.value <= TIME_COUNT) {
          count.value--;
        } else {
          isShowcode.value = true;
          clearInterval(timer.value);
          timer.value = 0;
        }
      }, 1000);
    }
  } else {
    if (!reg.test(formDatas.username as string)) {
      message.info('请输入正确的手机号');
      return false;
    }
    if (!timer.value) {
      count.value = TIME_COUNT;
      isShowcodes.value = false;
      timer.value = setInterval(() => {
        if (count.value > 0 && count.value <= TIME_COUNT) {
          count.value--;
        } else {
          isShowcodes.value = true;
          clearInterval(timer.value);
          timer.value = 0;
        }
      }, 1000);
    }
  }
  if (CodeShake.value) {
    return;
  }
  let send = {
    type: -1,
    mobile: formData.username,
  };
  let sends = {
    type: 0,
    mobile: formDatas.username,
  };
  http
    .getSendCaptcha(isLogin.value == true ? send : sends)
    .then((res) => {
      CodeShake.value = false;
    })
    .catch(() => {
      CodeShake.value = false;
    });
};
//忘记密码
const isLogin = ref<boolean>(true);
const forget = () => {
  isShowform.value = true;
  isLogin.value = !isLogin.value;
};
const loginShake = ref<boolean>(false);
// 客管登陆接口
const login = () => {
  if (loginShake.value == true) {
    return;
  }
  if (formData.username == '') {
    message.info('手机号不能为空');
    return;
  }
  if (isShowform.value == true && formData.password == '') {
    message.info('密码不能为空');
    return;
  }
  if (isShowform.value == false && formData.code == '') {
    message.info('验证码不能为空');
    return;
  }
  //密码登录
  let enroll = {
    account: formData.username,
    password: formData.password,
    type: 0,
    pid: studioId,
  };
  //验证码登录
  let valid = {
    account: formData.username,
    code: formData.code,
    type: 1,
    pid: studioId,
  };
  http
    .adminSubAccountLogin({ params: isShowform.value ? enroll : valid })
    .then(async (res) => {
      localStorage.setItem('subState', String(1));
      const resData = res.data.data;
      store.commit('user/subLoginSaveUserInfo', resData);
      await formatRoutes();
      router.addRoute({
        path: '/:catchAll(.*)',
        redirect: '/404',
      });
      message.success(res.data.message);
      store.dispatch('home/getDefaultCustomized').finally(() => {
        router.push({ name: 'Layout' });
        loginShake.value = false;
      });
    })
    .catch((err) => {
      message.error(err.data.error);
      loginShake.value = false;
    });
};
//客管修改密码登录
const modify = () => {
  if (formDatas.username == '') {
    message.info('手机号不能为空');
    return;
  }
  if (formDatas.code == '') {
    message.info('验证码不能为空');
    return;
  }
  if (formDatas.password == '') {
    message.info('旧密码不能为空');
    return;
  }
  if (formDatas.passwords == '') {
    message.info('新密码不能为空');
    return;
  }
  const data = {
    account: formDatas.username,
    code: formDatas.code,
    new_password: formDatas.password,
    rwd_password: formDatas.passwords,
  };
  http
    .adminSubForgotPassword(data)
    .then((res) => {
      message.success(res.data.message);
      isLogin.value = true;
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
const adminUserVisit = () => {
  http.adminUserVisit({}).then(() => {
    sessionStorage.setItem('visit', 'pc_login');
  });
};
const user_visit = sessionStorage.getItem('visit');
if (user_visit == null) {
  adminUserVisit();
}
//下级账号登录信息
const subData = {
  backgroun_url: '',
  background_id: '',
  copyright_info: '',
  login_copyright: '',
  logo_id: '',
  logo_url: '',
  phone: '',
};
const subStatus = ref<number>();
const showText = ref(false);
localStorage.setItem('sub_logo', String(studioId));
// let subAlias = sessionStorage.getItem('sub_logo');
const getSubAccountInfo = () => {
  let data = {
    sub_alias: studioId,
  };
  http
    .getSubAccountInfo({ params: data })
    .then((res) => {
      if (res.data.data.length == 0) {
        showText.value = true
      } 

        if (res.data.data != '') {
          subStatus.value = 1;
        }

        const data = res.data.data;
        subData.backgroun_url = data.backgroun_url;
        subData.background_id = data.background_id;
        subData.copyright_info = data.copyright_info;
        subData.login_copyright = data.login_copyright;
        subData.logo_id = data.logo_id;
        subData.logo_url = data.logo_url;
        subData.phone = data.phone;
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
getSubAccountInfo();

return (_ctx: any,_cache: any) => {
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "login-box",
    style: _normalizeStyle({
      backgroundImage: `url(${
        subStatus.value == 1 ? subData.backgroun_url : _ctx.process.env.VUE_APP_OTHER_LINK+'/9e9b0202112091428561425.png'
      })`,
    })
  }, [
    (_unref(headerNavVisiable) && !showText.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: subStatus.value == 1 ? subData.logo_url : ''
              }, null, 8, _hoisted_4)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        src: defaultTopLogo,
        alt: ""
      })
    ], 512), [
      [_vShow, !_unref(getDisplay)()]
    ]),
    (isLogin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h2", null, _toDisplayString(subStatus.value == 1 ? subData.login_copyright : '欢迎登录'), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(aInput), {
                style: {"font-size":"14px","height":"45px","border-radius":"4px"},
                class: "form_item_name",
                value: formData.username,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formData.username) = $event)),
                placeholder: "请输入手机号",
                onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (isShowform.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_a_input_password, {
                        style: {"font-size":"14px","height":"45px","border-radius":"4px"},
                        class: "form_input_pass",
                        value: formData.password,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formData.password) = $event)),
                        placeholder: "请输入密码",
                        onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;",
                        onKeyup: _withKeys(login, ["enter"])
                      }, null, 8, ["value", "onKeyup"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_unref(aInput), {
                        style: {"font-size":"14px","height":"45px","border-radius":"4px"},
                        class: "form_bottom_valid",
                        placeholder: "请输入验证码",
                        value: formData.code,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formData.code) = $event)),
                        onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                      }, null, 8, ["value"]),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("button", {
                          class: "wrap_form_button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (getCode()))
                        }, "获取验证码", 512), [
                          [_vShow, _unref(isShowcode)]
                        ]),
                        _withDirectives(_createElementVNode("span", { class: "wrap_form_vaild" }, " 获取验证码(" + _toDisplayString(_unref(count)) + ") ", 513), [
                          [_vShow, !_unref(isShowcode)]
                        ])
                      ])
                    ])
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("p", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (forget())),
              style: {"color":"#808080"}
            }, "忘记密码")
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (login()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("登 录")
              ]),
              _: 1
            }),
            (isShowform.value)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (isShowform.value = !isShowform.value))
                }, "验证码登录"))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (isShowform.value = !isShowform.value))
                }, "密码登录"))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            (isShowform.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_unref(aInput), {
                        style: {"font-size":"14px","border-radius":"4px"},
                        class: "form_item_name",
                        value: formDatas.username,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((formDatas.username) = $event)),
                        placeholder: "请输入手机号",
                        onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_unref(aInput), {
                        style: {"font-size":"14px","border-radius":"4px"},
                        class: "form_item_name",
                        placeholder: "请输入验证码",
                        value: formDatas.code,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((formDatas.code) = $event)),
                        onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("button", {
                        class: "wrap_form_button",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (getCode()))
                      }, "获取验证码", 512), [
                        [_vShow, _unref(isShowcodes)]
                      ]),
                      _withDirectives(_createElementVNode("span", { class: "wrap_form_vaild" }, " 获取验证码(" + _toDisplayString(_unref(count)) + ") ", 513), [
                        [_vShow, !_unref(isShowcodes)]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_a_input_password, {
                  style: {"font-size":"14px","border-radius":"4px","height":"45px"},
                  class: "form_input_pass",
                  value: formDatas.password,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((formDatas.password) = $event)),
                  placeholder: "请设置新密码(6~30位字符内容)",
                  onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_a_input_password, {
                  style: {"font-size":"14px","border-radius":"4px"},
                  class: "form_input_pass",
                  value: formDatas.passwords,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((formDatas.passwords) = $event)),
                  placeholder: "请设置新密码(6~30位字符内容)",
                  onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("p", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (forget())),
                style: {"color":"#808080"}
              }, "返回登录")
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (modify()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("立即修改")
                ]),
                _: 1
              })
            ])
          ])
        ])),
    (!showText.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(subStatus.value == 1
          ? subData.copyright_info
          : 'Copyright © 2022 www.qing.tv All Rights Reserved Powered by Shanghai Bonwey Technology Co., Ltd'), 1))
      : _createCommentVNode("", true)
  ], 4))
}
}

})